export default __webpack_public_path__ + "static/global_physical-c6eb6fe6402ea5a39832472ae8aca8e6.jpg";